import styles from './styles.module.scss';

export const EmptyState = ({ text = 'No documents' }) => (
  <div className={styles.emptyStateDocuments}>{text}</div>
);
